import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//---------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    Select, getDatefromWeekNum0, myAxios, handleFilesInput, 
    MyFormData,
    isDevMode, 
    CCTVReportWriterEmails, potholingReportWriterEmails,
} from "src/components/common/functions";
//---------------------------------------------
const title = "Reports";
//---------------------------------------------
export default function ReportForm({
    reportHashKey, 
    startDate, 
    endDate, 
    projectHashKey, 
    notes, 
    cadLocation,
    reportLocation, 
    videoLocation,
    pdfId, 
    code,
    priority,
    reportTechEmail, 
    pothole, 
    ep, 
    manhole,
    pending,
    sup,
    
    history, 
    keyword, 

    curWeekStart, 
    curWeekEnd, 

    setUserList, 
    closeIt, 
    projectsList, 
    reportWriterList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    //---------------------------------------------
    const [stats, setStats] = useState("");
    const [curProjectHashKey, setProjectHashKey] = useState(projectHashKey ?? "");
    const [curStartDate, setStartDate] = useState(startDate ?? "");
    const [curEndDate, setEndDate] = useState(endDate ?? "");
    const [curReportTechEmail, setReportTechEmail] = useState(reportTechEmail ?? "");
    const [curSup, setSup] = useState(sup ?? "");
    const [invalidText, setInvalidText] = useState("");
    const [dateFullRange, setDateFullRange] = useState({minTime: "1900-01-01", maxTime: "2999-12-31"});

    //---------------------------------------------
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        if(!formData.get("projectHashKey")){
            window.alert("Please select a project.");
            return;
        }
        if(curSup !== "Yes"){
            //-------------------------------------------------
            setShowLoader(true);
            const poRes = await myAxios("reports/validate.php", formData);
            setShowLoader(false);
            if(!poRes) return;
            //-------------------------------------------------
            const ranges = reportHashKey?
            poRes.data.filter(d => d.reportHashKey !== reportHashKey)
            :
            poRes.data;
            for(let range of ranges){
                const {startDate, endDate} = range;
                const before = formData.get("endDate") < startDate;
                const after = formData.get("startDate") > endDate;
                const valid = before || after;
                if(!valid){
                    setInvalidText(range);
                    window.alert("Time conflict. Please check.");
                    return;
                }else{
                    setInvalidText("");
                }
            }
        }
        const obj = projectsList.find(p => p.projectHashKey === formData.get("projectHashKey"));
        obj ?? formData.append("projectName", obj.projectName);
        formData.append("start", getDatefromWeekNum0(curWeekStart, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
        formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("reports/saveReport.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setUserList(res.data);
        history.push(`/${title}`);
    }
    const handleFormSave = async e => {
        const formData = new MyFormData(e);
        if(!formData.get("projectHashKey")){
            window.alert("Please select a project.");
            return;
        }
        if(!formData.get("reportTechEmail")){
            window.alert("Please select a report tech.");
            return;
        }
        formData.append("mode", "Save");
        if(curSup !== "Yes"){
            //-------------------------------------------------
            setShowLoader(true);
            const poRes = await myAxios("reports/validate.php", formData);
            setShowLoader(false);
            if(!poRes) return;
            //-------------------------------------------------
            const ranges = reportHashKey?
            poRes.data.filter(d => d.reportHashKey !== reportHashKey)
            :
            poRes.data;
            for(let range of ranges){
                const {startDate, endDate} = range;
                const before = formData.get("endDate") < startDate;
                const after = formData.get("startDate") > endDate;
                const valid = before || after;
                if(!valid){
                    setInvalidText(range);
                    window.alert("Time conflict. Please check.");
                    return;
                }else{
                    setInvalidText("");
                }
            }
        }
        const obj = projectsList.find(p => p.projectHashKey === formData.get("projectHashKey"));
        obj ?? formData.append("projectName", obj.projectName);
        formData.append("start", getDatefromWeekNum0(curWeekStart, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
        formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("reports/saveReport.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setUserList(res.data);
        history.push(`/${title}`);
    }
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("projectHashKey", curProjectHashKey);
            //-------------------------------------------------
            setShowLoader(true);
            const poRes = await myAxios("reports/readWeek.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoader(false);
            if(!poRes) return;
            //-------------------------------------------------
            setDateFullRange(poRes.data);
        }
        if(curProjectHashKey !== ""){
            getData();
        }
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [history, curProjectHashKey])
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword + " Report"}
            width = {"1200px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {"Submit"}
            onSave = {handleFormSave}
        >
            <div>
                <input
                    className = "nodisplay" readOnly
                    name = "action" value = {keyword}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "reportHashKey" value = {reportHashKey || ""}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "pdfId" value = {pdfId}
                />
                <div className = "my-4">
                    <label className = "inline font-weight-bold mr-3 required-field">Project Name:</label>
                    <Select
                        name = "projectHashKey"
                        defaultValue = {projectsList.find(p => p.projectHashKey === projectHashKey)}
                        onChange = {e => {
                            setStartDate("");
                            setEndDate("");
                            setInvalidText("");
                            setProjectHashKey(e?.value);
                        }}
                        options = {projectsList}
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "projectHashKey" value = {curProjectHashKey}
                    />
                </div>
                <div className = "my-4">
                    <label className = "inline font-weight-bold mr-3 required-field" htmlFor = "startDate">Start Date:</label>
                    <input
                        id = "startDate"
                        type = "date"
                        min = {dateFullRange.minTime || "1900-01-01"}
                        max = {dateFullRange.maxTime || "2999-12-31"} 
                        required
                        className = "form-control mr-3"
                        name = "startDate"
                        value = {curStartDate}
                        onChange = {e => {
                            setStartDate(e.currentTarget.value);
                            setInvalidText("");
                        }}
                    />
                    <label className = "inline font-weight-bold mr-3 required-field" htmlFor = "endDate">End Date:</label>
                    <input
                        id = "endDate"
                        type = "date"
                        min = {(curStartDate > dateFullRange.minTime?curStartDate : dateFullRange.minTime) || "1900-01-01"}
                        max = {dateFullRange.maxTime || "2999-12-31"}
                        required
                        className = "form-control"
                        name = "endDate"
                        value = {curEndDate}
                        onChange = {e => {
                            setEndDate(e.currentTarget.value);
                            setInvalidText("");
                        }}
                    />
                </div>
                {invalidText?
                <div className = "my-4 mx-3 text-danger font-weight-bold">
                    <span className = "mr-1">
                        conflict with
                    </span>
                    <Link to = {`/${title}/${invalidText.reportHashKey}`}>
                        from {invalidText.startDate} to {invalidText.endDate}
                    </Link>
                </div>
                :<></>}
                <div className = "my-4">
                    <label className = "inline mr-3 font-weight-bold" htmlFor = "reportTechEmail">Report Tech</label>
                    <select
                        required type = "text"
                        className = "form-control mr-3"
                        name = "reportTechEmail"
                        id = "reportTechEmail" 
                        value = {curReportTechEmail}
                        onChange = {e => {setReportTechEmail(e.currentTarget.value);}}
                    >
                        <option value = "">Select</option>
                        {reportWriterList.map((thisUser, key) => <option key = {key} value = {thisUser.email}>{thisUser.userName}</option>)}
                    </select>
  
                    <label className = "inline mr-3 font-weight-bold" htmlFor = "code">Code</label>
                    <input type = "text" name = "code" id = "code" defaultValue = {code} className = "form-control mr-3"/>
            
                    <label className = "inline mr-3 font-weight-bold" htmlFor = "priority">Priority</label>
                    <select type = "text" name = "priority" id = "priority" defaultValue = {priority} className = "form-control">
                        <option value = "">Select</option>
                        <option>Low</option>
                        <option>Medium</option>
                        <option>High</option>
                    </select>
                </div>
                {potholingReportWriterEmails.includes(curReportTechEmail)?
                <div className = "my-4">
                    <label className = "inline mr-3 font-weight-bold" htmlFor = "pothole"># of Potholes</label>
                    <input type = "number" name = "pothole" id = "pothole" defaultValue = {pothole} className = "form-control"/>

                    <label className = "inline mx-3 font-weight-bold" htmlFor = "ep"># of Electric Potholes</label>
                    <input type = "number" name = "ep" id = "ep" defaultValue = {ep} className = "form-control"/>
             
                    <label className = "inline mx-3 font-weight-bold" htmlFor = "manhole"># of Manholes</label>
                    <input type = "number" name = "manhole" id = "manhole" defaultValue = {manhole} className = "form-control"/>
                </div>
                :<></>}
                {potholingReportWriterEmails.includes(curReportTechEmail) && curProjectHashKey && curStartDate && curEndDate?
                <div>
                    <span className = "btn btn-info" onClick = {async() => {
                        const formData = new MyFormData();
                        formData.append("projectHashKey", curProjectHashKey);
                        formData.append("startDate", curStartDate);
                        formData.append("endDate", curEndDate);
                        setShowLoader(true);
                        const res = await myAxios("reports/readStats.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        if(!res.data.p.length && !res.data.ep.length && !res.data.manhole.length){
                            window.alert("No Data Sheets found.");
                        }
                        setStats(res.data);
                    }}>Get Stats</span>
                    {stats?<span className = "ml-3">{[
                        stats.p?stats.p + " Potholes":"", 
                        stats.ep?stats.ep + " Electric Potholes":"", 
                        stats.manhole?stats.manhole + " Manholes":""
                    ].filter(value => value).join(",  ")
                    }</span>:<></>}
                </div>
                :<></>}
                <div className = "my-4">
                    <label className = "inline font-weight-bold mr-3" htmlFor = "sup">Supplementary Report</label>
                    <select type = "text" name = "sup" id = "sup" value = {curSup} onChange = {e => {setSup(e.currentTarget.value);}} className = "form-control">
                        <option value = "">No</option>
                        <option>Yes</option>
                    </select>
                </div>
                <div className = "my-4">
                    <label className = "inline mr-3 font-weight-bold" htmlFor = "pending">Pending on Other Department</label>
                    <select type = "text" name = "pending" id = "pending" defaultValue = {pending} className = "form-control">
                        <option value = "">No</option>
                        <option>Yes</option>
                    </select>
                </div>
                <div className = "my-4">
                    <label className = "h4" htmlFor = "notes">
                        Notes:
                    </label>
                    <textarea
                        id = "notes"
                        name = "notes"
                        defaultValue = {notes || ""}
                        className = "form-control mb-3"
                        style = {{width: "100%"}}
                    />
                </div>
                {CCTVReportWriterEmails.includes(curReportTechEmail)?
                <div className = "my-4">
                    <label className = "my-4 h4">
                        CAD Local Path:
                    </label>
                    <textarea
                        name = "cadLocation"
                        defaultValue = {cadLocation || ""}
                        className = "form-control mb-3"
                        style = {{width: "100%"}}
                    />
                    <label className = "my-4 h4">
                        Video Local Path:
                    </label>
                    <textarea
                        name = "videoLocation"
                        defaultValue = {videoLocation || ""}
                        className = "form-control mb-3"
                        style = {{width: "100%"}}
                    />
                </div>
                :<></>}

                <div className = "my-4">
                    <label className = "my-4 h4">
                        Report Local Path (for large file):
                    </label>
                    <textarea
                        name = "reportLocation"
                        defaultValue = {reportLocation || ""}
                        className = "form-control mb-3"
                        style = {{width: "100%"}}
                    />
                </div>

                {keyword === "Add" || !pdfId?
                <div className = "my-4">
                    <label className = "inline h4" htmlFor = "pdf">Add file below:</label>
                    <div className = "custom-file">
                        <input
                            type = "file"
                            className = "custom-file-input"
                            id = "pdf"
                            name = "pdf"
                            onChange = {handleFilesInput}
                        />
                        <label className = "custom-file-label">Choose file</label>
                    </div>
                </div>
                :<></>}
            </div>
        </Modal>
    )
}